<template>
  <div>
    <v-wait for="loading">
      <HalfCircleSpinner slot="waiting" />
      <template slot="waiting">
        <div class="spinner-message my-3 text-center">
          Checking the token...
        </div>
      </template>
    </v-wait>
    <password-reset-confirm
      v-if="isFormDisplayed"
      :token="token"
      @form-submit="onSubmit($event)"
    />
    <message-form
      v-if="isResultDisplayed"
      :success="!!confirmSuccess"
      :message="confirmMessage"
    />
    <expired-form v-if="isExpiredDisplayed" :token="token" />
  </div>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
import Api from '@/providers/Api.js';
import { HalfCircleSpinner } from 'epic-spinners';
import PasswordResetConfirm from '@/components/auth/password/reset/PasswordResetConfirm';
import MessageForm from '@/components/auth/password/reset/MessageForm';
import ExpiredForm from '@/components/auth/password/reset/ExpiredForm';

export default {
  name: 'PasswordReset',
  components: {
    HalfCircleSpinner,
    PasswordResetConfirm,
    MessageForm,
    ExpiredForm,
  },
  data: function () {
    return {
      token: this.$route.params.token,
      isTokenValid: null,
      isTokenExpired: null,
      isSubmit: 0,
      confirmSuccess: null,
      confirmMessage: null,
    };
  },
  created: function () {
    this.$wait.start('loading');

    if (this.$store.getters.isAuthenticated) {
      this.$toasted.error('You are already logged in the system.', {
        duration: 3000,
      });
      this.$wait.end('loading');

      this.$router.push('/');
    } else {
      Api.checkTokenIsExpired(this.$route.params.token)
        .then((response) => {
          this.isTokenValid = response.data.isValid;
          this.isTokenExpired = response.data.isExpired;
          this.$wait.end('loading');
        })
        .catch((error) => {
          this.$toasted.error(error.response.data.message, { duration: 3000 });
          this.$wait.end('loading');

          this.$router.push({ path: `/login` });
        });
    }
  },
  computed: {
    isFormDisplayed: function () {
      return this.isTokenValid && !this.isSubmit && !this.isTokenExpired;
    },
    isResultDisplayed: function () {
      return this.isTokenValid && this.isSubmit && !this.isTokenExpired;
    },
    isExpiredDisplayed: function () {
      return this.isTokenExpired;
    },
  },
  methods: {
    onSubmit: function (data) {
      this.isSubmit = 1;
      this.confirmSuccess = data.success;
      this.confirmMessage = data.message;
    },
  },
};
</script>

<!-- ----------------------------------------------------------------------- -->

<style lang="scss"/>
